<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <b-form>
    <b-row class="mb-2">
      <b-col
        cols="12"
        lg="3"
      >
        <b-card
          no-body
          class="border"
        >
          <b-card-header>
            <b-card-title class="font-medium-2">
              <feather-icon
                icon="LockIcon"
                size="18"
              />
              <span class="align-middle ml-50">{{ $t('Role') }}</span>
            </b-card-title>
          </b-card-header>
          <b-card-body>
            <b-card-text>
              Chọn nhiều vai trò cùng lúc để có thêm nhiều quyền khác nhau.
            </b-card-text>
            <b-form-group>
              <b-form-checkbox
                v-for="val in rolesData"
                :key="val.display_name"
                v-model="roleIds"
                :value="val.id"
                :name="val.display_name"
                class="mb-1"
              >
                {{ val.display_name }}
              </b-form-checkbox>
            </b-form-group>
            <b-form-group>
              <b-button
                variant="primary"
                class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                :block="currentBreakPoint === 'xs'"
                :disabled="loading"
                @click="assignRole(userId, roleIds)"
              >
                {{ $t('Save Changes') }}
              </b-button>
            </b-form-group>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        lg="9"
      >
        <!-- PERMISSIONS -->
        <b-overlay
          :show="loadingPerms"
          spinner-variant="primary"
          spinner-type="grow"
          spinner-small
          rounded="sm"
        >
          <b-card
            class="border"
            no-body
          >
            <b-card-header>
              <b-card-title class="font-medium-2">
                <feather-icon
                  icon="LockIcon"
                  size="18"
                />
                <span class="align-middle ml-50">{{ $t('Permission') }}</span>
              </b-card-title>
            </b-card-header>
            <b-card-body>
              <b-card-text>
                Các quyền được cấp theo vai trò.
              </b-card-text>
              <b-input-group class="my-2">
                <b-form-input
                  v-model="searchPermQuery"
                  class="d-inline-block"
                  placeholder="Từ khóa"
                  @keydown.enter="searchPerm($event)"
                />
                <b-input-group-append>
                  <b-button
                    variant="primary"
                    @click.prevent.stop="searchPerm"
                  >
                    <feather-icon icon="SearchIcon" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>

              <b-card-group
                :columns="currentBreakPoint === 'md' || currentBreakPoint === 'lg' || currentBreakPoint === 'xl'"
                :deck="currentBreakPoint === 'xs' || currentBreakPoint === 'sm'"
              >
                <b-card
                  v-for="item in listPermissions"
                  v-if="isShowModule(item)"
                  :key="`module_${item.id}`"
                  :title="item.description"
                  class="border"
                >
                  <b-form-group>
                    <div
                      v-for="pem in item.permissions"
                      :key="`pem_${pem.id}`"
                      class="d-flex"
                    >
                      <template v-if="isShowPerm(pem.id)">
                        <div class="text-success">
                          <feather-icon
                            icon="CheckCircleIcon"
                            size="18"
                          />
                        </div>
                        <p class="mb-1 ml-50 text-black">
                          {{ `${pem.description} (${pem.name})` }}
                        </p>
                      </template>
                    </div>

                  </b-form-group>
                </b-card>
              </b-card-group>
              <!-- SAVE -->
              <div class="text-right">
                <b-button
                  variant="primary"
                  class="mt-2"
                  :block="currentBreakPoint === 'xs'"
                  :disabled="loading"
                  @click="assignRole(userId, roleIds)"
                >
                  {{ $t('Save Changes') }}
                </b-button>
              </div>
            </b-card-body>

          </b-card>
        </b-overlay>
      </b-col>
    </b-row>

  </b-form>
</template>

<script>
import {
  BRow, BCol, BForm,
  BFormGroup,
  BButton,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BFormCheckbox,
  BOverlay,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BCardGroup,
} from 'bootstrap-vue'
import { showToast } from '@core/utils/utils';
import router from '@/router';

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BFormCheckbox,
    BOverlay,
    BInputGroup,
    BInputGroupAppend,
    BCardGroup,
    BCardText,
  },
  props: {
    rolesData: {
      type: Array,
      required: true,
    },
    userData: {
      type: Object,
      required: true,
    },
    userId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      loadingPerms: false,
      searchPermQuery: '',
      searchPermIds: [],
      searchModuleIds: [],
      ownerPermIds: [],
      roleIds: this.userData.roles.map(o => o.id),
      listPermissions: this.userData.permissions,
      fields: [
        {
          key: 'name',
          label: 'Quyền',
          sortable: true,
        },
        {
          key: 'description',
          label: 'Diễn giải',
          sortable: false,
        },
        {
          key: 'perm_group',
          label: 'Module',
          sortable: true,
        },
      ],
    }
  },

  computed: {
    currentBreakPoint() {
      return this.$store.getters['app/currentBreakPoint'];
    },
  },
  watch: {
    roleIds(newValue, oldValue) {
      setTimeout(() => {
        this.fetchPermissions(newValue)
      }, 300)
    },
  },
  mounted() {
    this.fetchPermissions(this.roleIds);
  },
  methods: {
    isShowPerm(permId) {
      if (this.searchPermQuery === '') {
        return true;
      }
      return this.searchPermIds.find((val) => val === permId);
    },
    isOwnerPerm(permId) {
      return this.ownerPermIds.find((val) => val === permId);
    },
    isShowModule(mod) {
      return this.searchModuleIds.find((val) => val === mod.id) && mod.permissions.length;
    },
    resolvePermActiveVariant(permId) {
      return this.isOwnerPerm(permId) ? 'success' : 'secondary';
    },
    searchPerm(e) {
      e.preventDefault();
      e.stopPropagation();
      this.searchPermIds = [];
      this.searchModuleIds = [];
      this.listPermissions.forEach(mod => {
        mod.permissions.forEach(per => {
          if (per.name.toLowerCase().indexOf(this.searchPermQuery) > -1 || per.description.toLowerCase().indexOf(this.searchPermQuery) > -1) {
            this.searchPermIds.push(per.id);
            this.searchModuleIds.push(mod.id);
          }
        });
      });
    },
    fetchPermissions(data) {
      this.loadingPerms = true;
      this.$store.dispatch('users/fetchPermissions', data)
        .then((response) => {
          if (response.status === 200) {
            if (response.data.code === 200) {
              this.loadingPerms = false
              this.listPermissions = response.data.data.modules;
              this.listPermissions.forEach(mod => {
                this.searchModuleIds.push(mod.id);
              });
              // this.listPermissions.forEach(mod => {
              //   mod.permissions.forEach(per => {
              //     if (per.name.indexOf(this.searchPermQuery) > -1 || per.description.toLowerCase().indexOf(this.searchPermQuery) > -1) {
              //       this.searchPermIds.push(per.id);
              //     }
              //   });
              // });
              this.searchPermIds = response.data.data.permissions;
            }
          }
        })
    },
    assignRole(userid, roleIds) {
      this.loading = true;
      this.$store.dispatch('users/assignRole', {
        id: userid,
        data: roleIds,
      })
        .then((response) => {
          // console.log('response.data', response.data);
          if (response.data.code === 200) {
            this.loading = false;
            const msg = response.data.message;
            const variant = response.data.code === 200 ? 'success' : 'danger';
            showToast(msg, { variant })
            if (response.data.code === 200) {
              router.push({ name: 'users-list' })
            }
          }
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
